import { SortingState } from '@tanstack/react-table'
import { Button } from '@wartek-id/button'
import { Icon } from '@wartek-id/icon'
import { Pagination } from '@wartek-id/pagination'
import { useMedia } from '@wartek-id/react-utils'

import { trackClickDetailNpsn } from '@/utils/tracker/modules/datainduk'
import { TrackerSection, TrackerSubSection } from '@/utils/tracker/shared'
import { BasicDataRow, SatpenListResponse } from '@/apis/types'

import { DEFAULT_LIMIT } from '@/modules/DataInduk/helpers'

import { EmptyState } from '@/components/EmptyState'
import { RoundedTable } from '@/components/RoundedTable/RoundedTable'
import { RoundedTableLoader } from '@/components/RoundedTable/RoundedTableLoader'

import { SATPEN_TABLE_COLUMN } from './columns'
import { SatpenCellRenderer } from './SatpenCellRenderer'

interface TableProps {
  isPending: boolean
  emptyMessage: string
  data?: SatpenListResponse
  page: number
  sorting: SortingState
  onSortingChange?: (newSorting: SortingState) => void
  handleChangePage: (page: number) => void
  handleOpenDialog: (row: BasicDataRow) => void
  onReset?: () => void
}

export const SatpenTable = ({
  isPending,
  emptyMessage,
  data,
  page,
  handleChangePage,
  handleOpenDialog,
  onReset,
  sorting,
  onSortingChange,
}: TableProps) => {
  const isMd = useMedia('(min-width: 768px)', false)

  return (
    <section id="table-section">
      {isPending ? (
        <RoundedTableLoader rows={20} />
      ) : (
        <>
          {(data?.data || []).length > 0 ? (
            <>
              <RoundedTable
                columns={SATPEN_TABLE_COLUMN}
                data={(data?.data || []).map((item, index) => ({
                  no: `${index + 1 + (data?.meta?.offset || 0)}`,
                  ...item,
                }))}
                withSummary={false}
                CustomCellRenderer={({ row, col }) => {
                  return (
                    <SatpenCellRenderer
                      row={row}
                      col={col}
                      onClickNpsn={(row) => {
                        handleOpenDialog(row)
                        trackClickDetailNpsn({
                          npsn: row.npsn,
                          section: TrackerSection.SATPEN,
                          subSection: TrackerSubSection.PAUD_DIKDASMEN,
                        })
                      }}
                    />
                  )
                }}
                withSort={true}
                manualSorting={true}
                enableSortColumns={{
                  namaDesa: 1,
                  bentukPendidikanGroup: 1,
                }}
                sorting={sorting}
                onSortingChange={onSortingChange}
              />

              <div
                className="mt-4 flex items-center justify-center"
                data-testid="pagination-root"
              >
                <Pagination
                  currentPage={page}
                  pageSize={DEFAULT_LIMIT}
                  onPageChange={handleChangePage}
                  totalCount={data?.meta?.total || 0}
                  siblingCount={isMd ? 1 : 0}
                />
              </div>
            </>
          ) : (
            <>
              <EmptyState
                title="Data tidak ditemukan"
                description={emptyMessage}
                size="sm"
              >
                <div className="text-center">
                  <Button onClick={onReset}>
                    Reset Pilihan
                    <Icon color="inverse" className="ml-2">
                      refresh
                    </Icon>
                  </Button>
                </div>
              </EmptyState>
            </>
          )}
        </>
      )}
    </section>
  )
}
